import React from 'react';
import NativeSelect, { SelectChangeEvent } from '@mui/material/Select';
import { GridTableContext } from '../contexts';

export function SelectFilter({
  defaultValue,
  onChange,
  options,
  value,
  label
}: {
  options: { [value: string]: string };
  defaultValue?: string;
  value?: string;
  onChange: (value: string) => void;
  label: string;
}): JSX.Element {
  const {
    instance: { gotoPage }
  } = React.useContext(GridTableContext);
  return (
    <NativeSelect
      native
      sx={{
        mr: 1,
        ml: 1
      }}
      variant='standard'
      label={label}
      defaultValue={defaultValue}
      onChange={(event: SelectChangeEvent<string>): void => {
        gotoPage(0);
        onChange(event.target.value);
      }}
      value={value}
    >
      {Object.entries(options).map(([value, text]) => (
        <option key={value} value={value}>
          {text}
        </option>
      ))}
    </NativeSelect>
  );
}
